import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type {
  UpdateUserGroupRequest,
  UserGroupRecord,
} from "../UserGroupRecord";

import * as UseUserGroups from "./useUserGroups";

interface UpdateUserGroupArgs {
  userGroupId: string;
  updates: UpdateUserGroupRequest;
}

export function useUpdateUserGroup() {
  const { userGroupService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<UserGroupRecord, Error, UpdateUserGroupArgs>({
    mutationFn: ({ userGroupId, updates }) =>
      userGroupService.update(userGroupId, updates),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: UseUserGroups.getQueryKey(),
      });
    },
  });
}
